import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { beforeGuard } from './guard/index'
import Layout from '../views/layout/index.vue'
import Login from '../views/Login.vue'
import Statistics from '../views/Statistics.vue'
import Setting from '../views/Setting.vue'
import Users from '../views/Users.vue'
import Supplier from '../views/supplier/Index.vue'
import AddSupplier from '../views/supplier/Add.vue'
import EditSupplier from '../views/supplier/Edit.vue'
import WorkOrder from '../views/workOrder/Index.vue'
import EditWorkOrder from '../views/workOrder/Edit.vue'
import Cates from '../views/goods/Cates.vue'
import Goods from '../views/goods/Index.vue'
import AddGoods from '../views/goods/Add.vue'
import EditGoods from '../views/goods/Edit.vue'
import Company from '../views/company/Index.vue'
import Companycates from '../views/company/Cates.vue'
import AddCompany from '../views/company/Add.vue'
import EditCompany from '../views/company/Edit.vue'
import Members from '../views/Members.vue'
import Orders from '../views/Orders.vue'
import Setmeal from '../views/Setmeal.vue'
import Cards from '../views/cards/Index.vue'
import CardsEdit from '../views/cards/Edit.vue'
import CardsAdd from '../views/cards/Add.vue'
import CardsTemplet from '../views/cards/Templet.vue'
import Bidding from '../views/bidding/Index.vue'
import Banners from '../views/Banners.vue'
import Qa from '../views/Qa/Index.vue'
import QaAdd from '../views/Qa/Add.vue'
import QaEdit from '../views/Qa/Edit.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: '数据统计',
    redirect: '/statistics',
  },
  {
    path: '/statistics',
    name: '工作台',
    component: Layout,
    children:[
      {
        name: '工作台',
        path: '/statistics',
        component: Statistics,
      }
    ]
  },
  {
    path: '/banners',
    name: 'banners设置',
    component: Layout,
    children:[
      {
        name: 'banners设置',
        path: '/banners',
        component: Banners,
      }
    ]
  },
  {
    name: '登录',
    path: '/login',
    component: Login
  },
  {
    path: '/setting',
    name: '网站设置',
    component: Layout,
    children:[
      {
        name: '网站设置',
        path: '/setting',
        component: Setting,
      }
    ]
  },
  {
    path: '/users',
    name: '管理员管理',
    component: Layout,
    children:[
      {
        name: '管理员列表',
        path: '/users',
        component: Users,
      }
    ]
  },
  {
    path: '/members',
    name: '用户管理',
    component: Layout,
    children:[
      {
        name: '用户列表',
        path: '/members',
        component: Members,
      }
    ]
  },
  {
    path: '/cards',
    name: '名片管理',
    component: Layout,
    children:[
      {
        name: '名片列表',
        path: '/cards',
        component: Cards,
      },
      {
        name: '创建名片',
        path: '/cards/add',
        component: CardsAdd,
      },
      {
        name: '名片编辑',
        path: '/cards/edit/:id',
        component: CardsEdit,
      },
      {
        name: '名片样式',
        path: '/cards/templet',
        component: CardsTemplet,
      },
    ]
  },
  {
    path: '/company',
    name: '公司列表',
    component: Layout,
    children:[
      {
        name: '公司列表',
        path: '/company',
        component: Company,
      },
      {
        name: '公司添加',
        path: '/company/add',
        component: AddCompany,
      },
      {
        name: '公司编辑',
        path: '/company/edit/:id',
        component: EditCompany,
      },
      {
        name: '公司分类',
        path: '/companycates',
        component: Companycates,
      }
    ]
  },
  {
    path: '/cates',
    name: '产品品类',
    component: Layout,
    children:[
      {
        name: '品类列表',
        path: '/cates',
        component: Cates,
      }
    ]
  },
  {
    path: '/goods',
    name: '产品列表',
    component: Layout,
    children:[
      {
        name: '产品列表',
        path: '/goods',
        component: Goods,
      },
      {
        name: '创建产品',
        path: '/goods/add',
        component: AddGoods,
      },
      {
        name: '编辑产品',
        path: '/goods/edit/:id',
        component: EditGoods,
      }
    ]
  },
  {
    path: '/supplier',
    name: '服务商管理',
    component: Layout,
    children:[
      {
        name: '服务商列表',
        path: '/supplier',
        component: Supplier,
      },
      {
        name: '添加服务商',
        path: '/supplier/add',
        component: AddSupplier,
      },
      {
        name: '编辑服务商',
        path: '/supplier/edit/:id',
        component: EditSupplier,
      }
    ]
  },
  {
    path: '/workOrder',
    name: '工单管理',
    component: Layout,
    children:[
      {
        name: '工单列表',
        path: '/workOrder',
        component: WorkOrder,
      },
      {
        name: '编辑工单',
        path: '/workOrder/edit/:id',
        component: EditWorkOrder,
      },
    ]
  },
  {
    path: '/orders',
    name: '订单管理',
    component: Layout,
    children:[
      {
        name: '订单列表',
        path: '/orders',
        component: Orders,
      },
    ]
  },
  {
    path: '/setmeal',
    name: '套餐管理',
    component: Layout,
    children:[
      {
        name: '套餐列表',
        path: '/setmeal',
        component: Setmeal,
      },
    ]
  },
  {
    path: '/bidding',
    name: '竞投广告',
    component: Layout,
    children:[
      {
        name: '竞投广告',
        path: '/bidding',
        component: Bidding,
      },
    ]
  },
  {
    path: '/qa',
    name: '问题答疑',
    component: Layout,
    children:[
      {
        name: '问题答疑',
        path: '/qa',
        component: Qa,
      },
      {
        name: '创建答疑',
        path: '/qa/add',
        component: QaAdd,
      },
      {
        name: '编辑答疑',
        path: '/qa/edit/:id',
        component: QaEdit,
      },
    ]
  },
]
const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  try {
      /* 检测路径 */
      await beforeGuard.rediectPath(to, from, next)

      /* 调整路由参数 */
      await beforeGuard.parsePath(to, from, next)
      
      /* 检测登录状态 */
      await beforeGuard.checkLogin(to, from, next)
      
      /* 检测权限 */
      await beforeGuard.checkPerm({ to, from, next })
  } catch (error) {
      console.log(error)
  }
})

export default router
